import React from "react";
import { Spinner } from "flowbite-react";

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading...",
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-8 mt-20 w-full max-w-3xl mx-auto">
      <Spinner size="xl" className="mb-4" />
      <span className="text-gray-600 dark:text-gray-300 text-lg font-medium">
        {message}
      </span>
    </div>
  );
};

export default LoadingState;
